<div class="propero-home">
  <section id="home" class="ph-hero ph-hero--compact">
    <div class="ph-hero__blob ph-hero__blob--brand" aria-hidden="true"></div>
    <div class="ph-hero__blob ph-hero__blob--accent" aria-hidden="true"></div>
    <div class="ph-container">
      <a routerLink="/calculators" class="ph-hero__back">
        <i class="lni lni-arrow-left" aria-hidden="true"></i>
        {{ 'CALCULATORS.BACK' | translate }}
      </a>
      <h1 class="ph-hero__title">{{ 'CALCULATOR2.TITLE' | translate }}</h1>
      <p class="ph-hero__subtitle">{{ 'CALCULATOR2.TEXT' | translate }}</p>
    </div>
  </section>

  <section id="calculator" class="ph-section ph-section--muted">
    <div class="ph-container">
      <div class="ph-calc-layout">
        <form [formGroup]="formGroup" (ngSubmit)="calculate()" class="ph-calc-form-card ph-calc-form">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'CALCULATOR2.LOAN_AMOUNT' | translate }}</mat-label>
            <input type="text" formControlName="loanAmount" matInput />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'CALCULATOR2.LOAN_PERIOD' | translate }}</mat-label>
            <input type="text" formControlName="loanPeriod" matInput />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'CALCULATOR2.INTEREST_RATE' | translate }}</mat-label>
            <input type="text" formControlName="interestRate" matInput />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'CALCULATOR2.ANNUAL_TAXES' | translate }}</mat-label>
            <input type="text" formControlName="annualTaxes" matInput />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'CALCULATOR2.ANNUAL_INSURANCE' | translate }}</mat-label>
            <input type="text" formControlName="annualInsurance" matInput />
          </mat-form-field>
          <button type="submit" class="ph-btn ph-btn--brand ph-btn--block ph-btn--lg" [disabled]="!formGroup.valid">
            {{ 'CALCULATOR2.COMPUTE' | translate }}
          </button>
        </form>

        <div class="ph-calc-results">
          <article class="ph-result-card">
            <div class="ph-result-card__icon"><i class="lni lni-calculator"></i></div>
            <p class="ph-result-card__value">{{ totalPayment | number : '1.2-2' }} €</p>
            <p class="ph-result-card__label">{{ 'CALCULATOR2.TOTAL_PAYMENT' | translate }}</p>
            <span class="ph-result-card__hint">{{ 'CALCULATOR2.PERIOD' | translate }}</span>
          </article>
          <article class="ph-result-card">
            <div class="ph-result-card__icon"><i class="lni lni-grow"></i></div>
            <p class="ph-result-card__value">{{ amountPaid | number : '1.2-2' }} €</p>
            <p class="ph-result-card__label">{{ 'CALCULATOR2.AMOUNT_PAID' | translate }}</p>
            <span class="ph-result-card__hint">{{ 'CALCULATOR2.MONTHLY' | translate }}</span>
          </article>
          <article class="ph-result-card">
            <div class="ph-result-card__icon"><i class="lni lni-euro"></i></div>
            <p class="ph-result-card__value">{{ taxes | number : '1.2-2' }} €</p>
            <p class="ph-result-card__label">{{ 'CALCULATOR2.TAXES' | translate }}</p>
            <span class="ph-result-card__hint">{{ 'CALCULATOR2.MONTHLY' | translate }}</span>
          </article>
          <article class="ph-result-card">
            <div class="ph-result-card__icon"><i class="lni lni-alarm-clock"></i></div>
            <p class="ph-result-card__value">{{ insurance | number : '1.2-2' }} €</p>
            <p class="ph-result-card__label">{{ 'CALCULATOR2.INSURANCE' | translate }}</p>
            <span class="ph-result-card__hint">{{ 'CALCULATOR2.MONTHLY' | translate }}</span>
          </article>
        </div>
      </div>
    </div>
  </section>

  <section id="contact" class="ph-section ph-section--contact">
    <div class="ph-container ph-contact__grid">
      <div class="ph-contact__info">
        <h2 class="ph-contact__title">{{ 'HOME.SECTION_CONTACTUS_HEADING' | translate }}</h2>
        <p class="ph-contact__lead">{{ 'HOME.SECTION_CONTACTUS_TEXT' | translate }}</p>
        <div class="ph-contact__channels">
          <div class="ph-contact__channel">
            <div class="ph-contact__channel-icon"><i class="lni lni-phone"></i></div>
            <div>
              <div class="ph-contact__channel-label">Telefon</div>
              <div class="ph-contact__channel-value">{{ 'COMPANY.CONTACT_MAIN_PHONE' | translate }}</div>
            </div>
          </div>
          <div class="ph-contact__channel">
            <div class="ph-contact__channel-icon"><i class="lni lni-envelope"></i></div>
            <div>
              <div class="ph-contact__channel-label">Email</div>
              <div class="ph-contact__channel-value">{{ 'COMPANY.CONTACT_MAIN_EMAIL' | translate }}</div>
            </div>
          </div>
        </div>
      </div>
      <form #contactForm="ngForm" (ngSubmit)="send()" class="ph-contact__form" novalidate>
        <div class="ph-field">
          <label for="c2-name">{{ 'HOME.NAME' | translate }}</label>
          <input id="c2-name" type="text" name="name" [(ngModel)]="contactItem.subject" required [placeholder]="'HOME.NAME' | translate" />
        </div>
        <div class="ph-field">
          <label for="c2-email">{{ 'HOME.EMAIL' | translate }}</label>
          <input id="c2-email" type="email" name="email" [(ngModel)]="contactItem.email" required email [placeholder]="'HOME.EMAIL' | translate" />
        </div>
        <div class="ph-field">
          <label for="c2-message">{{ 'HOME.MESSAGE' | translate }}</label>
          <textarea id="c2-message" name="message" rows="4" [(ngModel)]="contactItem.content" required [placeholder]="'HOME.MESSAGE' | translate"></textarea>
        </div>
        <button type="submit" class="ph-btn ph-btn--brand ph-btn--block ph-btn--lg" [disabled]="contactForm.invalid || isLoading">
          <span *ngIf="!isLoading">{{ 'HOME.SEND' | translate }}</span>
          <span *ngIf="isLoading">{{ 'HOME.SENDING' | translate }}</span>
        </button>
        <p *ngIf="contactSuccess" class="ph-contact__success">Mesaj trimis! Te contactăm în curând.</p>
      </form>
    </div>
  </section>
</div>
